export const SECRET_KEY = "d931d86bbcd7c15b9de479683b7842b5066ff9cd2a81c273e833f367da5ad6fa"
